import styled from "styled-components";

export const ProjectDetailsWindowContainer = styled.div`
  width: 500px;
  height: 550px;
`;

export const ProjectDetailsImageContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 1rem;
  justify-content: center;
`;
export const ProjectDetailsImage = styled.img`
  width: 350px;
  height: 200px;
  object-fit: cover;
  box-shadow: ${(props) => props.theme.invertedStandardBoxShadow};
  padding: 4px;
`;
